export { default } from './FrequentlyAskedQuestions';
